import { z } from 'zod'

export const accessTokenSchema = z.object({
  token: z.string(),
  refreshToken: z.string()
})

export interface AccessToken extends z.infer<typeof accessTokenSchema> {}
